import { render, staticRenderFns } from "./AddExpenseHead.vue?vue&type=template&id=28a70e88&"
import script from "./AddExpenseHead.vue?vue&type=script&lang=js&"
export * from "./AddExpenseHead.vue?vue&type=script&lang=js&"
import style0 from "./AddExpenseHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports